import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { bankTransferService } from '../services/bankTransferService';
import type {
  BankTransferSearchParams,
  ConfirmReceiptRequest,
  ExtendDeadlineRequest,
} from '../types/bankTransfer';

export const BANK_TRANSFER_KEYS = {
  all: ['bank-transfers'] as const,
  list: (params?: BankTransferSearchParams) =>
    [...BANK_TRANSFER_KEYS.all, 'list', params] as const,
};

export const useBankTransferQueue = (params?: BankTransferSearchParams) =>
  useQuery({
    queryKey: BANK_TRANSFER_KEYS.list(params),
    queryFn: () => bankTransferService.listQueue(params),
  });

export const useConfirmReceipt = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      bookingId,
      request,
      idempotencyKey,
    }: {
      bookingId: string;
      request: ConfirmReceiptRequest;
      idempotencyKey: string;
    }) => bankTransferService.confirmReceipt(bookingId, request, idempotencyKey),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BANK_TRANSFER_KEYS.all });
    },
  });
};

export const useExtendDeadline = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      bookingId,
      request,
      idempotencyKey,
    }: {
      bookingId: string;
      request: ExtendDeadlineRequest;
      idempotencyKey: string;
    }) => bankTransferService.extendDeadline(bookingId, request, idempotencyKey),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BANK_TRANSFER_KEYS.all });
    },
  });
};
